export const DEFAULT_STALE_TIME = Infinity;
export const DEFAULT_RETRIES = 1;
